import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { VueReCaptcha } from "vue-recaptcha-v3";
import { createPinia, PiniaVuePlugin } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate'

Vue.use(VueCompositionAPI);
Vue.config.productionTip = false;

Vue.use(VueReCaptcha, { 
  siteKey: "6Ld2hXkhAAAAAEBGpFbrt8P_-axny6UD1ZZnht7B", 
});
Vue.use(PiniaVuePlugin);

const pinia = createPinia();
pinia.use(createPersistedState({
  storage: sessionStorage
}))

new Vue({
  router,
  vuetify,
  pinia,
  render: (h) => h(App)
}).$mount('#app');
